import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getDayAr'
})
export class GetDayArPipe implements PipeTransform {

  weekDaysInEnglishAndArabic = {
    Sunday: 'الأحد',
    Monday: 'الإثنين',
    Tuesday: 'الثلاثاء',
    Wednesday: 'الأربعاء',
    Thursday: 'الخميس',
    Friday: 'الجمعة',
    Saturday: 'السبت'
  };
  
  
  transform(value: string): string {
    return this.weekDaysInEnglishAndArabic[value];
  }

}
